import React from 'react'

const Page = () => {
  return <div>This is a Page</div>
}

export default Page
